import type { NodeContent } from '~/interfaces/page';

function findTipTapContentNode(
  nodeContent: NodeContent,
  nodeType: string,
  predicate: (nodeContent: NodeContent) => boolean = () => true,
) {
  let foundNode: NodeContent | undefined;

  if ('type' in nodeContent && nodeContent.type === nodeType && predicate?.(nodeContent)) {
    foundNode = nodeContent;
  } else if ('content' in nodeContent && Array.isArray(nodeContent.content)) {
    nodeContent.content.forEach((contentNode) => {
      if (!foundNode) {
        foundNode = findTipTapContentNode(contentNode as NodeContent, nodeType, predicate);
      }
    });
  }

  return foundNode;
}

function findTipTapContentNodes(
  nodeContent: NodeContent,
  nodeType: string,
  predicate: (nodeContent: NodeContent) => boolean = () => true,
) {
  const foundNodes: NodeContent[] = [];

  if ('type' in nodeContent && nodeContent.type === nodeType && predicate?.(nodeContent)) {
    foundNodes.push(nodeContent);
  } else if ('content' in nodeContent && Array.isArray(nodeContent.content)) {
    nodeContent.content.forEach((contentNode) => {
      foundNodes.push(...findTipTapContentNodes(contentNode as NodeContent, nodeType, predicate));
    });
  }

  return foundNodes;
}

function findMultipleTipTapContentNodes(
  nodeContent: NodeContent,
  nodeTypes: string[],
  predicate: (nodeContent: NodeContent) => boolean = () => true,
): Record<string, NodeContent | null> {
  const results: Record<string, NodeContent | null> = Object.fromEntries(nodeTypes.map((type) => [type, null]));

  function traverse(node: NodeContent) {
    if ('type' in node && nodeTypes.includes(node.type) && predicate(node)) {
      if (!results[node.type]) {
        results[node.type] = node;
      }
    }

    if ('content' in node && Array.isArray(node.content)) {
      for (const child of node.content) {
        traverse(child as NodeContent);

        // Early exit if all nodes found
        if (Object.values(results).every((v) => v !== null)) return;
      }
    }
  }

  traverse(nodeContent);
  return results;
}

export { findMultipleTipTapContentNodes, findTipTapContentNode, findTipTapContentNodes };
